import { render, staticRenderFns } from "./modalCategoria.vue?vue&type=template&id=b1af1254&scoped=true&"
import script from "./modalCategoria.vue?vue&type=script&lang=js&"
export * from "./modalCategoria.vue?vue&type=script&lang=js&"
import style0 from "./modalCategoria.vue?vue&type=style&index=0&id=b1af1254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1af1254",
  null
  
)

export default component.exports